<template>
  <OuterCasing :isScroll="isScroll">
    <LoadingComponents />
    <router-view></router-view>
  </OuterCasing>
</template>

<script>
import OuterCasing from "$common/components/outer-casing";
import LoadingComponents from '$superAppUser/components/loading-components';
import '$h5sdkSrc/index.js';

export default {
  components: {
    OuterCasing,
    LoadingComponents
  },
  mounted() {
  },
  data() {
    return {
      isScroll: false,
      scrollNames: []
    }
  },
  watch: {
    $route(val) {
      this.isScroll = !!(this.$root.getIosVersion && this.$root.getIosVersion.length && this.$root.getIosVersion[0] < 12 && this.scrollNames.indexOf(val.name) !== -1);
    }
  }
};
</script>
<style lang="stylus">
html, body {
  height: auto;
  min-height: 100%;
}
.sharecode-rule-btn {
    position: absolute;
    box-sizing: border-box;
    top: 40px;
    right: 0px;
    min-width: 56px;
    height: 24px;
    line-height: 24px;
    background: #F4FFD3;
    padding: 0 8px 0 19px;
    box-shadow: 0px 2px 4px 0px rgba(255,76,0,0.21);
    border-radius: 10px 0 0 10px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 11px;
    color: #FC2040;
}
</style>
